import { useMemo } from "react";
import { useSelector } from "../../../redux/hooks";
import { currentUserEmailSelector } from "../../../redux/slices/auth/selectors";
import { ApproveStatus, ApproverDetails } from "../../../types/claim";

/**
 * isPreviousPriorityApproverApproved = null : first approver
 * isPreviousPriorityApproverApproved = true : previous approver approved
 * isPreviousPriorityApproverApproved = false : previous approver not approved
 * isPreviousPriorityApproverApproved = undefined : paymentApprovers not exist
 */
const useIsPreviousApproverApproved = (paymentApprovers: ApproverDetails[]) => {
    const currentUserEmail = useSelector(currentUserEmailSelector);
    const validPaymentApprovers = useMemo(() => {
        return paymentApprovers.filter(
            (it) => it.status !== ApproveStatus.INVALID,
        );
    }, [paymentApprovers]);

    const currentPaymentApprovers = useMemo(() => {
        return validPaymentApprovers.find(
            (it) => it.details.email === currentUserEmail,
        );
    }, [validPaymentApprovers, currentUserEmail]);

    const isPreviousPriorityApproverApproved = useMemo(() => {
        const currentApproverIndex = validPaymentApprovers.findIndex(
            (it) => it.details.email === currentPaymentApprovers?.details.email,
        );

        if (currentApproverIndex === -1) {
            return;
        }
        const previousApproverIndex = currentApproverIndex - 1;

        const isPreviousApproverApprovedOrInvalid =
            paymentApprovers[previousApproverIndex]?.status ===
                ApproveStatus.APPROVED ||
            paymentApprovers[previousApproverIndex]?.status ===
                ApproveStatus.INVALID;

        return previousApproverIndex >= 0
            ? isPreviousApproverApprovedOrInvalid
            : null;
    }, [currentPaymentApprovers, paymentApprovers, validPaymentApprovers]);
    return isPreviousPriorityApproverApproved;
};

export default useIsPreviousApproverApproved;
